<template>
	<c-dialog ref="dialog" title="采购单详情" height="75vh" :button="false">
		<c-title style="margin: .3rem .3rem 0;">订单信息</c-title>
		<c-detail style="padding-top: 0;">
			<c-detail-item label="采购单号">
				{{detailInfo.purchase_code}}
			</c-detail-item>
			<c-detail-item label="采购数(台)">
				{{detailInfo.purchase_count}}
			</c-detail-item>
			<c-detail-item label="数据统计">
				<c-state color="#AD78CE" type="tag">收</c-state> <span style="margin-right: .5em;">{{detailInfo.purchase_product_count}}台</span>
				<c-state color="#0078FF" type="tag">验</c-state> <span style="margin-right: .5em;">{{detailInfo.checked_count}}台</span>
				<c-state color="#FF0000" type="tag">退</c-state> <span style="margin-right: .5em;">{{detailInfo.return_count}}台</span>
			</c-detail-item>
			<c-detail-item label="采购类型">
				<span v-if="detailInfo.purchase_type == 1">线下采购</span>
				<span v-if="detailInfo.purchase_type == 2">线上采购</span>
			</c-detail-item>
			<template v-if="detailInfo.purchase_type == 1">
				<c-detail-item label="供应商">
					{{detailInfo.supplier_name||'-'}}
				</c-detail-item>
				<c-detail-item label="供应商联系人">
					{{detailInfo.supplier_contact_realname||'-'}}
				</c-detail-item>
			</template>
			<template v-if="detailInfo.purchase_type == 2">
				<c-detail-item label="售卖人">
					{{detailInfo.seller_name||'-'}}
				</c-detail-item>
				<c-detail-item label="售卖人电话">
					{{detailInfo.seller_phone||'-'}}
				</c-detail-item>
				<c-detail-item label="售卖人地址">
					{{detailInfo.seller_address||'-'}}
				</c-detail-item>
			</template>
			<c-detail-item label="回收金额">
				￥{{detailInfo.purchase_money}}
			</c-detail-item>
			<c-detail-item label="采购部门">
				{{detailInfo.purchase_dept_name||'-'}}
			</c-detail-item>
			<c-detail-item label="采购人">
				{{detailInfo.purchase_user_realname||'-'}}
			</c-detail-item>
			<c-detail-item label="创建部门">
				{{detailInfo.create_dept_name||'-'}}
			</c-detail-item>
			<c-detail-item label="创建人">
				{{detailInfo.create_user_realname||'-'}}
			</c-detail-item>
			<c-detail-item label="创建时间">
				{{detailInfo.create_date||'-'}}
			</c-detail-item>
		</c-detail>

		<c-title style="margin: 0 .3rem;">产品信息</c-title>
		<view-list-card v-for="(item, i) in productList" :key="i" style="margin-bottom: .24rem; background: #F9F9F9;">
			<template v-if="item.level_type" #tag>
				<c-state dict="LEVEL_TYPE" :value="item.level_type" type="hollow"></c-state>
			</template>

			<template #name>
				{{[item.brand_name, item.spu_model_name, item.color_name, item.memory_name].filter(item => item).join(' ')}}
			</template>

			<template #default>
				<c-field label="背贴码">{{item.produce_unique_code}}</c-field>
				<c-field label="IMEI">{{item.produce_imei}}</c-field>
				<c-field label="采购价">￥{{item.purchase_price}}</c-field>
				<c-field label="同行价">￥{{item.market_price}}</c-field>
				<c-field label="零售价">￥{{item.retail_price}}</c-field>
			</template>
		</view-list-card>
	</c-dialog>
</template>

<script>
	export default {
		name: 'purchaseOrderDetail',

		props: {
			orderId: [String, Number]
		},

		data() {
			return {
				detailInfo: {},
				productList: []
			}
		},

		methods: {
			open() {
				this.request({
					url: '/purchase/order/detail',
					data: {
						purchase_order_id: this.orderId
					},
					loading: true,
					success: data => {
						this.detailInfo = data.detailInfo;
						this.productList = data.productList;
						this.$refs.dialog.open();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>